<template>
  <div class="relative" :class="sideMenu ? 'md:hidden px-4 z-0 mt-2' : 'px-4'">
    <Swiper
      v-if="categories && categories.length"
      :options="swiperOption"
      navigation
      class="flex justify-start overflow-x-auto"
    >
      <swiper-slide
        class="category flex mb-8 bg-white jcc border border-gray-50"
        v-for="(category, i) in categories"
        :key="i"
        :class="selectedCategory == category ? 'active' : 'filter grayscale'"
      >
        <div
          v-wave
          class=" flex justify-center truncate aic px-4 w-full shadow-lg"
          @click="selecCategory(category)"
        >
          <div class="mr-4 hidden md:block" :class="sideMenu ? 'catg-in w-12' : 'w-8 catg-in-img'">
            <img
              :src="category.image ? storageUrl + category.image : '/dish.webp'"
              :alt="category.name"
              class="w-full"
            />
          </div>
          <span class="truncate text-sm text-center font-medium">{{ category.name }}</span>
        </div>
      </swiper-slide>

    </Swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  data() {
    return {
      swiperOption: {
        breakpoints: {
          1024: {
            slidesPerView: 'auto',
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
          640: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          320: {
            // centeredSlides: true,
            slidesPerView: 2,
            spaceBetween: 10,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  components: { Swiper, SwiperSlide },
  methods: {
    selecCategory(category) {
      this.$store.commit("product/setSelectedCategory", category);
      this.$store.dispatch("product/getProducts", {
        category: category,
        restaurantId: this.restaurantId,
      });
      this.$store.dispatch("product/getAttributeItems", {
        category: category,
        restaurantId: this.restaurantId,
      });
    },
  },
  computed: {
    sideMenu(){
      if(process.env.VUE_APP_SIDEMENU == 'side_menu') {
        return true
      }
      else {
        return false
      }
    },
    storageUrl() {
      return process.env.VUE_APP_STORAGE_URL;
    },
    categories() {
      return this.$store.state.orderiomApiPackage.product.categories;
    },
    selectedCategory() {
      return this.$store.state.orderiomApiPackage.product.selectedCategory;
    },
    restaurantId() {
      return process.env.VUE_APP_RESTAURANT_ID;
    },
  },
  // created() {
  //   console.log(this.restaurantId);

  //   this.$store.dispatch("auth/auth");
  //   this.$store
  //     .dispatch("product/getCategories", process.env.VUE_APP_RESTAURANT_ID)
  //     .then(() => {
  //       console.log(this.categories);
  //     });
  // },
};
</script>

<style>
/* .owl-carousel .owl-item img {
  width: 40px !important;
} */
span.swiper-pagination-bullet {
  background: lightgrey;
}
span.swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: darkgrey;
}
</style>
